const Reviews = [
  {
    id: 1,
    video: "/A PROYECTO.mp4", 
   
  },
  {
    id: 2,
    video: "/A PROYECTOO.mp4", 
  
  },
  {
    id: 3,
    video: "/AAA PROYECTO.mp4", 

  },

];

export default Reviews;
